import React, { Component } from 'react'
import Swal from 'sweetalert2'
import jwt_decode from "jwt-decode"
import { AuthProvider } from '../../contexts/auth.context'
import { AuthLoading } from './'
import { token } from '../../config/access-token'
import { UserModel, } from '../../models'
import { locationFunc } from "../../utils"

const user_model = new UserModel()

class Auth extends Component {
  state = {
    authcertifying: true,
    authenticated: false,
    permissions: [],
    user: {},
  }

  componentDidMount() {
    // this.getlocation()
    this._initiateAuthentication()
  }

  async getlocation() {
    await navigator.geolocation.getCurrentPosition((position) => {
      if(position){
        localStorage.setItem('location', JSON.stringify({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        }))
      }else{
        Swal.fire({ title: "ไม่สามารถล็อคอินได้ !", text: `ค้นหาที่อยู่ปัจจุบันไม่ได้ กรุณาเปิดระบุตำเเหน่ง`, icon: "warning", })
      }
    },() => { 
      Swal.fire({ title: "ไม่สามารถล็อคอินได้ !", text: `ค้นหาที่อยู่ปัจจุบันไม่ได้ กรุณาเปิดระบุตำเเหน่ง`, icon: "warning", })
    }, { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 });
  }
  
  _checkLogin = async ({ user_username, user_password, keep_station }) => {
    // const location = JSON.parse(localStorage.getItem('location'))
    // if(!location || !location.latitude || !location.longitude) await this.getlocation()
    const res_login = await user_model.checkLoginPos({ user_username, user_password, })

    if (res_login.require === false) {
      this.setState({ authcertifying: false, }, () => {
        Swal.fire({ title: "ไม่สามารถล็อคอินได้ !", text: 'คำขอเกิดข้อผิดพลาด', icon: "error", })
      })
    } else if (res_login.data.length === 0) {
      this.setState({ authcertifying: false, }, () => {
        Swal.fire({ title: "ไม่สามารถล็อคอินได้ !", text: 'โปรดตรวจสอบชื่อผู้ใช้และรหัสผ่านของคุณ', icon: "warning", })
      })
    } else if (!res_login.data[0].permission_pos) {
      this.setState({ authcertifying: false, }, () => {
        Swal.fire({ title: "ไม่สามารถล็อคอินได้ !", text: 'ไม่มีสิทธิ์เข้าถึงหน้า POS', icon: "warning", })
      })

    } else if (res_login.data.length && res_login.data[0].close_shift_today) {
      Swal.fire({ title: "ไม่สามารถล็อคอินได้ !", text: 'วันนี้คุณปิดกะไปแล้ว', icon: "warning", }).then(() => {
        try {
          localStorage.clear()
          window.location.reload()
        } catch (e) {
          console.log('_handleLogout ', e)
        }
      })
    } else {
      //  const result = await this.compareBranchDistance(res_login.data[0])
      const result = true

      if (!result) {
        this.setState({ authcertifying: false, }, () => {
          Swal.fire({ title: "ไม่สามารถล็อคอินได้ !", text: `ไม่อยู่ในระยะสาขาที่ตั้งค่าไว้`, icon: "warning", })
        })
      }else{
        try {
          localStorage.setItem('x-access-token', res_login.x_access_token)
          localStorage.setItem('session-user', JSON.stringify(res_login.data[0]))

          if (!keep_station) {
            localStorage.removeItem('session-station-setting')
          }

          token['x-access-token'] = res_login.x_access_token

          const { permissions } = jwt_decode(res_login.permissions_token)

          this.setState({
            authcertifying: false,
            authenticated: true,
            permissions: permissions || [],
            user: res_login.data[0],
          })
        } catch (e) {
          this.setState({
            authcertifying: false,
          }, () => {
            console.log('_checkLogin ', e)
          })
        }
      }
    }
  }

  async compareBranchDistance(user) {
    console.log('user_location ',user.user_location);
    if(!user.user_location && user.user_locations){
      const location = JSON.parse(localStorage.getItem('location'))
      const branch_locations = user.user_locations.filter(val => val.user_location_status && val.company_branch_latitude && val.company_branch_longitude && val.company_branch_radius)
      console.log('branch_locations ',branch_locations.length);
      if(!location){
        return false
      }else if(branch_locations.length){
        let result = false

        for(const branch of branch_locations){
          const distance = locationFunc.calculateDistance(
            branch.company_branch_latitude,
            branch.company_branch_longitude,
            location.latitude,
            location.longitude,
          )

          if(distance <= branch.company_branch_radius){
            console.log(`TRUE ${branch.company_branch_name} : ${distance} / ${branch.company_branch_radius}`);
            result = true
          }else{
            console.log(`FALSE ${branch.company_branch_name} : ${distance} / ${branch.company_branch_radius}`);
          }
        }
        return result
      }else{
        return true
      }
    }else{
      return true
    }
  }

  _initiateAuthentication = () => {
    try {
      const session_user = localStorage.getItem('session-user')

      if (session_user) {
        const { user_username, user_password, } = JSON.parse(session_user)

        this._checkLogin({ user_username, user_password, keep_station: true, })
      } else {
        this.setState({ authcertifying: false, })
      }
    } catch (e) {
      this.setState({
        authcertifying: false,
      }, () => {

        localStorage.clear()

        console.log('_initiateAuthentication ', e)
      })
    }
  }

  _handleLogin = (data) => !this.state.authcertifying && this.setState({ authcertifying: true, }, () => this._checkLogin(data))

  _handleLogout = () => {
    try {
      localStorage.clear()
      window.location.reload()
    } catch (e) {
      console.log('_handleLogout ', e)
    }
  }

  render() {
    return (
      <AuthProvider
        value={{
          ...this.state,
          _handleLogin: this._handleLogin,
          _handleLogout: this._handleLogout,
          _initiateAuthentication: this._initiateAuthentication,
        }}
      >
        {this.state.authcertifying ? <AuthLoading /> : this.props.children}
      </AuthProvider>
    )
  }
}

export default Auth